<div class="fixed -translate-y-[60px]">
	@if ($opened()) {
		<div
			class="side-nav-actions-menu"
			@menuAnimation
		>
			<div class="flex content-center items-stretch gap-1 self-stretch px-7">
				@for (column of $columns(); track column.id) {
					<div class="column-item flex flex-1 flex-col items-start gap-5 will-change-[transform,opacity]">
						<span
							class="font-display text-xs font-bold uppercase leading-5 tracking-[1px] text-on-background"
						>
							{{ column.label }}
						</span>

						<div class="flex min-w-[160px] flex-col content-center items-start gap-4 self-stretch">
							@for (item of column.items; track item.id) {
								<button
									class="flex items-center gap-1 self-stretch transition-all duration-200 ease-out"
									(click)="onAction(item)"
								>
									<div
										class="h-6 w-6 rounded-full p-1"
										[class]="column.backgroundColor"
									>
										<uikit-icon
											[name]="item.icon"
											size="small"
											[fill]="column.iconColor"
										/>
									</div>

									<span
										class="text-left font-body text-base font-normal leading-6 text-on-background"
									>
										{{ item.label }}
									</span>
								</button>
							}
						</div>
					</div>

					@if (!$last) {
						<div>
							<uikit-divider
								[vertical]="true"
								class="h-full"
							/>
						</div>
					}
				}
			</div>
		</div>
	}
</div>
